import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Tile from './Tile';

const BoardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.cols || 8}, 1fr);
  gap: 8px;
  width: fit-content;
  margin: 25px auto;
  padding: 0;
  background: transparent;
  border-radius: 20px;
  backdrop-filter: none;
  border: none;
  box-shadow: none;
`;

const Board = ({ grid, onTileClick, selectedTiles, animationState, setAnimationState, playerId, isProcessingMove, totalPlayers }) => {
  const numCols = grid[0]?.length || 8;
  const [swappingTiles, setSwappingTiles] = useState([]);
  
  useEffect(() => {
    if (animationState.lastSwapped && animationState.lastSwapped.length > 0) {
      setSwappingTiles(animationState.lastSwapped);
      const timer = setTimeout(() => {
        setSwappingTiles([]);
        setAnimationState(prevState => ({ ...prevState, lastSwapped: [] }));
      }, 1000); // Animation duration is 1s

      return () => clearTimeout(timer);
    }
  }, [animationState.lastSwapped, setAnimationState]);

  return (
    <BoardContainer cols={numCols}>
      {grid.map((row, rowIndex) =>
        row.map((tile, colIndex) => {
          const isSelected = selectedTiles.some(
            t => t.row === rowIndex && t.col === colIndex
          );

          const lastFoundWordTiles = animationState.lastFound || [];
          const isPartOfLastFoundWord = lastFoundWordTiles.some(t => t.row === rowIndex && t.col === colIndex);
          
          let animationDelay = 0;
          if (isPartOfLastFoundWord) {
            const tileIndex = lastFoundWordTiles.findIndex(t => t.row === rowIndex && t.col === colIndex);
            animationDelay = tileIndex * 0.15;
          }
          
          const isSwapping = swappingTiles.some(t => t.row === rowIndex && t.col === colIndex);

          return (
            <Tile
              key={`${rowIndex}-${colIndex}`}
              {...tile}
              onClick={() => onTileClick(rowIndex, colIndex)}
              selected={isSelected}
              isFound={isPartOfLastFoundWord}
              isSwapping={isSwapping}
              animationDelay={animationDelay}
              playerId={playerId}
              isProcessingMove={isProcessingMove}
              totalPlayers={totalPlayers}
            />
          );
        })
      )}
    </BoardContainer>
  );
};

export default Board; 